import { routeName } from "../utils";
import pageConfig from "@/config/page";
const page = pageConfig.pages.accounts;

const name = "accounts";

export default {
  name,
  path: name,
  component: () => import("@/layout/routerView"),
  meta: {
    disable: true,
  },
  children: [
    {
      path: "paper",
      name: routeName("paper", name),
      redirect: { name: routeName("paper.index", name) },
      component: () => import("@/layout/routerView"),
      children: [
        {
          name: routeName("paper.index", name),
          path: "",
          component: page.paper.index,
          props: true,
          meta: {
            defaultProps: {
              username: "",
            },
          },
        },
        {
          name: routeName("paper.user", name),
          path: ":username",
          component: page.paper.index,
          props: true,
        },
        {
          name: routeName("paper.bet", name),
          path: ":username/bet",
          component: page.paper.bet,
          props: true,
        },
      ],
    },
    {
      name: routeName("history", name),
      component: () => import("@/layout/routerView"),
      redirect: { name: routeName("history.index", name) },
      path: "history",
      children: [
        {
          name: routeName("history.index", name),
          path: "",
          component: page.history.index,
          props: { hasUser: false },
        },
        {
          name: routeName("history.user", name),
          path: ":username",
          component: page.history.index,
          props: { hasUser: true },
        },
      ],
    },
    {
      name: routeName("bet", name),
      component: page.bet,
      path: "bet",
    },
    {
      name: routeName("income", name),
      component: () => import("@/layout/routerView"),
      redirect: { name: routeName("income.index", name) },
      path: "income",
      children: [
        {
          name: routeName("income.index", name),
          component: page.income.index,
          path: "",
        },
        {
          name: routeName("income.detail", name),
          component: page.income.detail,
          path: ":startDate/:endDate",
          props: true,
        },
      ],
    },
    {
      name: routeName("finance", name),
      component: page.finance,
      path: "finance",
    },
    {
      name: routeName("transfer", name),
      component: page.transfer,
      path: "transfer",
    },
    {
      name: routeName("return_bonus", name),
      component: page.return_bonus,
      path: "return_bonus",
    },
    {
      name: routeName("profit", name),
      component: page.profit,
      path: "profit",
    },
    {
      name: routeName("high_profit_members", name),
      component: page.high_profit_members,
      path: "high_profit_members",
    },
    {
      name: routeName("member_monthly_profit", name),
      component: () => import("@/layout/routerView"),
      redirect: { name: routeName("member_monthly_profit.index", name) },
      path: "member_monthly_profit",
      children: [
        {
          name: routeName("member_monthly_profit.index", name),
          component: page.member_monthly_profit.index,
          path: "",
        },
        {
          name: routeName("member_monthly_profit.detail", name),
          component: page.member_monthly_profit.detail,
          path: "detail",
          props: true,
        },
      ],
    },
    {
      name: routeName("game_report", name),
      component: page.game_report,
      path: "game_report",
    },
  ],
};
